import React from "react";
import { Helmet } from "react-helmet";

const SeoContent = ({ title, image, description, url, keywords }) => {
  return (
    <Helmet>
      <title>{title ?? "Fazaa used cars"}</title>
      <meta
        name="description"
        content={description ?? "This is a sample meta description"}
      />
      <meta
        name="keywords"
        content={
          keywords ?? "used cars sale, used cars abu dhabi, used cars dubai"
        }
      />

      {/* ************************************************* open graph ********************************* */}
      <meta property="og:title" content={title ?? "Fazaa used cars"} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url ?? "https://www.fazaa.ae"} />
      <meta
        property="og:image"
        content={
          image ??
          "https://www.fazaa.ae/upload/services/used-cars-service-1729571054771.jpg"
        }
      />

      <meta
        property="og:description"
        content={description ?? "This is a sample meta description"}
      />

      <meta property="og:site_name" content="Fazaa Used Cars" />

      {/* ************************************************* Twitter card ********************************* */}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ?? "Fazaa used cars"} />
      <meta
        name="twitter:description"
        content={description ?? "This is a sample meta description"}
      />
      <meta
        name="twitter:image"
        content={
          image ??
          "https://www.fazaa.ae/upload/services/used-cars-service-1729571054771.jpg"
        }
      />
    </Helmet>
  );
};

export default SeoContent;
